<template>
  <div id="imprint">
    <h3>Impressum</h3>
    <b>Angaben gemäß § 5 TMG:</b><br>
    <br>
    <b>Büroanschrift + Management:</b><br>
    <br>
    Frank Sauerbrey<br>
    Marstallstr. 1<br>
    99423 Weimar<br>
    <br>
    <b>Ust-ID-Nr.:</b><br>
    DE 162/265/07233<br>
    <br>
    <b>Kontakt:</b><br>
    <br>
    Telefon: +49 1511 5213865<br>
    E-Mail: info(at)gents-of-jazz.de<br>
    <br>
    <b>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</b><br>
    <br>
    Frank Sauerbrey<br>
    Adresse: siehe oben<br>
    <br>
    Stefan Rauschelbach<br>
    Ernst-Thälmann-Straße 65<br>
    99423 Weimar<br>
    <br>
    <b>Quellenangaben für die verwendeten Bilder und Grafiken</b><br>
    <br>
    Promofotos von Niclas Zimmer<br>
    Livebilder von Michael Stock<br>
    <br>
    <h3>Haftungsausschluss (Disclaimer)</h3><br>
    <br>
    <b>Haftung für Inhalte</b><br>
    <br>
    Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.<br>
    <br>
    <b>Haftung für Links</b><br>
    <br>
    Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.<br>
    <br>
    <b>Urheberrecht</b><br>
    <br>
    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
  </div>
</template>

<script>
export default {
  name: 'Imprint'
}
</script>

<style lang="scss" scoped>
  #imprint{
    padding: 5em 10em;
    background-color: #0d0d0d;
    color: white;
    @media all and (max-width: 540px)  {
      padding: 2em 2em 5em 2em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/partials/Imprint/Imprint.vue